import axios from "axios";
import config from "../config";
import { getAccessToken } from "../utils";
import { handleApiError } from "../components/errorBoundary/errorUtils";

const currentDomain = process.env.REACT_APP_DOMAIN;
const domainConfig = config[currentDomain];
const endpoint = domainConfig.apiEndpoint;

export const fetchDatasetsApi = async (projectID) => {
  try {
    const access_token = getAccessToken();
    const response = await axios.get(
      `${endpoint}project/dataset/?project=${projectID}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    const datasetsData = response.data.datasets;

    // if (!Array.isArray(datasetsData)) {
    //   throw new Error("API did not return an array of datasets");
    // }

    return datasetsData;
  } catch (error) {
    return handleApiError(error);
  }
};
